module.exports = __webpack_public_path__ + "img/salt.f5258b6e.svg";